<template>
  <v-slide-y-transition>
    <section class="notification" :class="`notification--${resource.type}`">
      <v-icon class="notification__icon">{{ resource.icon }}</v-icon>

      <section class="notification__body">
        <strong> {{ resource.title }}</strong>
        <span> {{ resource.message }}</span>
      </section>
    </section>
  </v-slide-y-transition>
</template>

<script>
export default {
  name: "NotificationComponent",

  props: {
    resource: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 12px;
  box-shadow: rgba(138, 138, 138, 0.1) 0px 10px 50px;

  .notification__icon {
    padding: 5px;
    border-radius: 22px;
    color: #ffffff;
  }

  &--warning {
    background: #fff5ef;

    .notification__icon {
      background: #ee8208;
    }
  }

  .notification__body {
    display: flex;
    flex-direction: column;
    text-align: left;

    strong {
      font-size: 14px;
      font-weight: 600;
    }

    span {
      font-size: 12px;
    }
  }
}
</style>
